<script lang="ts">
  import { onDestroy } from 'svelte';
  import { closeSnackbar, snackbarStore } from '../store/snackbar_store';
  import Icon from './Icon.svelte';

  let snackbar;

  // Subscribe to the snackbar store
  const unsubscribe = snackbarStore.subscribe(state => {
    snackbar = state;
  });

  // Clean up the subscription when the component is destroyed
  onDestroy(() => {
    unsubscribe();
  });
</script>

<div class={`snackbar ${snackbar.isOpen ? 'open' : ''} ${snackbar.type}`}>
  <span>{snackbar.message}</span>
  {#if snackbar.showCloseIcon}
    <button on:click={closeSnackbar}>
      <Icon glyph="close" desktopSize={18} />
    </button>
  {/if}
</div>

<style lang="scss">
  @import '../styles/colors.new.scss';
  .snackbar {
    position: fixed;
    bottom: 20px;
    display: none;
    left: 50%;
    transform: translateX(-50%);
    background-color: $neutral-dark-01;
    color: $primary-white;
    padding: 12px;
    border-radius: 8px;
    align-items: center;
    opacity: 0;
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;
    z-index: 0;
    font-size: 14px;
    width: -webkit-fill-available;
    justify-content: space-between;
    @include responsive {
      bottom: 8rem;
    }
    &.open {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
      z-index: 99999;
      display: flex;
    }

    &.info {
      background-color: $neutral-dark-01;
    }

    &.success {
      background-color: $functional-green-01;
    }

    &.error {
      background-color: $alert-danger;
    }

    &.warning {
      background-color: $functional-orange;
    }

    button {
      background: none;
      border: none;
      color: $primary-white;
      cursor: pointer;
    }
  }
</style>
